const SocketEndpoint = {
  GET_CREDENTIALS: '/default/socket/get-credentials',
  GET_ADDRESS: '/default/socket/get-address',
};

export default SocketEndpoint;
